"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.selectLowerMaxBetBetslipBet = exports.selectIsAnyOddHaveError = exports.selectFilteredRestrictionsByOddId = exports.selectRestrictionsByBetslipRestrictionsId = exports.makeSelectRestrictionByCondition = exports.selectRestrictionsByBetslipBet = exports.selectBetslipRestrictions = exports.selectBetslipRestrictionsIdFromProps = exports.selectRestrictionsState = void 0;
var re_reselect_1 = __importDefault(require("re-reselect"));
var reselect_1 = require("reselect");
var lodash_1 = require("lodash");
var betslip_1 = __importDefault(require("@gin-betting/betslip"));
var core_1 = __importStar(require("@gin-betting/core"));
var utils_1 = require("./utils");
var _a = betslip_1.default.selectors, selectBetslipBet = _a.selectBetslipBet, selectBetslipBetIdFromProps = _a.selectBetslipBetIdFromProps;
var selectOddIdFromProps = core_1.default.entities.selectors.selectOddIdFromProps;
var selectRestrictionsState = function (_, props) {
    return props.restrictionsState;
};
exports.selectRestrictionsState = selectRestrictionsState;
var selectBetslipRestrictionsIdFromProps = function (_, _a) {
    var betslipRestrictionsId = _a.betslipRestrictionsId;
    return betslipRestrictionsId;
};
exports.selectBetslipRestrictionsIdFromProps = selectBetslipRestrictionsIdFromProps;
exports.selectBetslipRestrictions = reselect_1.createSelector(exports.selectRestrictionsState, function (props) { return props.betslipRestrictions; });
exports.selectRestrictionsByBetslipBet = re_reselect_1.default(exports.selectBetslipRestrictions, selectBetslipBet, function (betslipRestrictions, betslipBet) {
    var _a;
    if (!betslipBet)
        return [];
    var betslipOddIds = betslipBet.betslipOddIds, mode = betslipBet.mode;
    if (mode === core_1.GQL.BetType.SINGLE) {
        return betslipOddIds.reduce(function (acc, betslipOddId) {
            var betslipRestrictionsId = utils_1.getBetslipRestrictionId(betslipOddId);
            var restrictions = betslipRestrictions.get(betslipRestrictionsId);
            if (!restrictions)
                return acc;
            return acc.concat(restrictions);
        }, []);
    }
    var betslipRestrictionsId = utils_1.getBetslipRestrictionId(betslipOddIds);
    return (_a = betslipRestrictions.get(betslipRestrictionsId)) !== null && _a !== void 0 ? _a : [];
})(selectBetslipBetIdFromProps);
var makeSelectRestrictionByCondition = function (restrictionType) {
    return reselect_1.createSelector(exports.selectBetslipRestrictions, exports.selectBetslipRestrictionsIdFromProps, function (betslipRestrictions, betslipRestrictionsId) {
        var betslipRestriction = betslipRestrictions.get(betslipRestrictionsId);
        return betslipRestriction === null || betslipRestriction === void 0 ? void 0 : betslipRestriction.find(function (r) { return restrictionType === r.type; });
    });
};
exports.makeSelectRestrictionByCondition = makeSelectRestrictionByCondition;
exports.selectRestrictionsByBetslipRestrictionsId = reselect_1.createSelector(exports.selectBetslipRestrictions, exports.selectBetslipRestrictionsIdFromProps, function (betslipRestrictions, betslipRestrictionsId) {
    var betslipRestriction = betslipRestrictions.get(betslipRestrictionsId);
    return betslipRestriction !== null && betslipRestriction !== void 0 ? betslipRestriction : [];
});
exports.selectFilteredRestrictionsByOddId = reselect_1.createSelector(exports.selectRestrictionsByBetslipRestrictionsId, selectOddIdFromProps, function (betslipRestriction, oddIdFromProps) {
    return utils_1.filterRestrictionsByOddId(betslipRestriction, oddIdFromProps);
});
exports.selectIsAnyOddHaveError = re_reselect_1.default(exports.selectRestrictionsByBetslipBet, function (restrictions) {
    var simpleRestrictions = utils_1.normalizeRestriction(restrictions).simpleRestrictions;
    return simpleRestrictions.length > 0;
})(selectBetslipBetIdFromProps);
exports.selectLowerMaxBetBetslipBet = re_reselect_1.default(exports.selectRestrictionsByBetslipBet, function (restrictions) {
    var _a, _b;
    var maxBetValues = restrictions
        .filter(utils_1.maxBetRestrictionCondition)
        .map(function (restriction) { return restriction.maxBet; });
    return (_b = (_a = lodash_1.min(maxBetValues)) === null || _a === void 0 ? void 0 : _a.toString()) !== null && _b !== void 0 ? _b : '';
})(selectBetslipBetIdFromProps);
//# sourceMappingURL=selectors.js.map